(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsuk-catalogue-filters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsuk-catalogue-filters')) {
    customElements.define('tsuk-catalogue-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.inputs = [...this.querySelectorAll('select')];
        const params = new URLSearchParams(location.search);
        const preserve = url => {
          for (const [key, value] of params) {
            if (key === 'sort_by' || key === 'preview_theme_id' || key.startsWith('filter.')) url.searchParams.append(key, value);
          }
          return url;
        };
        this.querySelectorAll('[data-brand-link]').forEach(link => { link.href = preserve(new URL(link.href)).href; });
        const resetLink = this.querySelector('[data-reset-link]');
        if (params.has('preview_theme_id')) {
          const resetUrl = new URL(resetLink.href);
          resetUrl.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
          resetLink.href = resetUrl.href;
        }
        const navigate = (replace = false, top = false) => {
          const url = new URL(this.dataset.base, location.origin);
          const tags = this.inputs.map(input => input.value).filter(Boolean);
          if (this.dataset.brand) tags.push(this.dataset.brand);
          if (tags.length) url.pathname = url.pathname.replace(/\/$/, '') + '/' + tags.join('+');
          preserve(url);
          if (!top) url.hash = 'tsuk-catalog';
          if (replace) location.replace(url.href); else location.assign(url.href);
        };
        this.inputs.forEach(input => input.addEventListener('change', () => navigate(false, input.dataset.filter === 'gender')));
        let legacy = false;
        const handle = value => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        for (const input of this.inputs) {
          const kind = input.dataset.filter;
          const value = params.get('tsuk_' + kind);
          if (!value) continue;
          const wanted = handle((kind === 'size' ? 'UK-' : kind === 'brand' ? 'Brand-' : '') + value);
          if ([...input.options].some(option => option.value === wanted)) { input.value = wanted; legacy = true; }
        }
        const oldBrand = params.get('tsuk_brand');
        if (oldBrand) {
          const wanted = handle('Brand-' + oldBrand);
          if ([...this.querySelectorAll('[data-brand-link]')].some(link => new URL(link.href).pathname.split('/').pop().split('+').includes(wanted))) { this.dataset.brand = wanted; legacy = true; }
        }
        if (legacy && Number(this.dataset.total) > 0) navigate(true, params.has('tsuk_gender') && !params.has('tsuk_brand') && !params.has('tsuk_size'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsuk-footwear-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsuk-preview-catalog')) {
    customElements.define('tsuk-preview-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.genderInput = this.querySelector('[data-tsuk-gender]');
        this.sizeInput = this.querySelector('[data-tsuk-size]');
        this.brandInput = this.querySelector('[data-tsuk-brand]');
        this.cards = [...this.querySelectorAll('.tsuk-edit__card')];
        const params = new URLSearchParams(location.search);
        this.genderInput.value = params.get('tsuk_gender') || '';
        this.sizeInput.value = params.get('tsuk_size') || '';
        this.brandInput.value = params.get('tsuk_brand') || '';
        this.genderInput.addEventListener('change', () => this.applyFilters());
        this.sizeInput.addEventListener('change', () => this.applyFilters());
        this.brandInput.addEventListener('change', () => this.applyFilters());
        this.querySelector('[data-tsuk-reset]').addEventListener('click', () => {
          this.genderInput.value = '';
          this.sizeInput.value = '';
          this.brandInput.value = '';
          this.applyFilters();
        });
        this.applyFilters();
      }
      applyFilters() {
        let count = 0;
        for (const card of this.cards) {
          const matches = (!this.genderInput.value || card.dataset.gender === this.genderInput.value) && (!this.sizeInput.value || card.dataset.size === this.sizeInput.value) && (!this.brandInput.value || card.dataset.brand === this.brandInput.value);
          card.hidden = !matches;
          if (matches) count++;
        }
        this.querySelector('[data-tsuk-count]').textContent = count;
        this.querySelector('[data-tsuk-empty]').hidden = count !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsuk-newsletter-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsuk-welcome-offer')) {
    customElements.define('tsuk-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || !this.dialog.showModal) return;
        this.preview = this.dataset.mode === 'preview';
        const explicitPreview = new URLSearchParams(location.search).get('tsuk_offer_preview') === '1';
        const editor = this.dataset.designMode === 'true';
        if (this.preview && !explicitPreview && !editor) return;
        this.hidden = false;
        this.querySelector('[data-offer-preview]').hidden = !this.preview;
        const success = this.querySelector('[data-offer-success]');
        const errors = this.querySelector('[data-offer-errors]');
        const key = 'tsuk-welcome-dismissed-v1';
        const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
        const remember = () => { try { sessionStorage.setItem(key, '1'); } catch { /* Dismissal still works with storage blocked. */ } };
        this.open = () => {
          if (this.dialog.open) return;
          this.dialog.showModal();
          this.querySelector('[data-offer-close]').focus({preventScroll:true});
          if (success) success.focus();
        };
        this.querySelector('[data-offer-open]').addEventListener('click', this.open);
        this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => { if (!this.preview) remember(); });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.querySelector('form').addEventListener('submit', event => {
          if (this.preview) event.preventDefault();
        });
        if (success || errors || explicitPreview) { this.open(); return; }
        if (this.preview || editor || dismissed() || !['index','collection','product'].includes(this.dataset.page)) return;
        this.timer = setTimeout(() => {
          this.scrollContainer = this.closest('.page-wrapper') || document.scrollingElement;
          this.prompt = () => {
            const scrollPosition = Math.max(window.scrollY, this.scrollContainer?.scrollTop || 0);
            if (document.hidden || scrollPosition < 160 || dismissed() || document.querySelector('dialog[open]')) return;
            const focused = document.activeElement;
            if (focused && /INPUT|TEXTAREA|SELECT/.test(focused.tagName)) return;
            this.open();
            document.removeEventListener('scroll', this.prompt, true);
          };
          document.addEventListener('scroll', this.prompt, {passive:true, capture:true});
          this.prompt();
        }, 15000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.prompt) document.removeEventListener('scroll', this.prompt, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
